import React from 'react';
import './Footer.css';

const Footer = () => {
    return (
        <div className="footer-container">
            <h1><b>EMPATHI</b></h1>
        </div>
    );
};


export default Footer;
